const getters = {
    madeReservations: state => state.madeReservations,
    receivedReservations: state => state.receivedReservations,
};

export default getters;